var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.isAuthenticated)?_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":_vm.signup}},[_vm._v(" Sign Up ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }